const { makeStyles } = require('@material-ui/core')

const styles = makeStyles({
  list: {
    marginBottom: '1rem',
    listStyleType: 'disc',
    paddingLeft: '20px !important',
    overflow: 'auto',
    '& li': {
      listStyle: 'disc'
    }
  }
})

export { styles }
